export const FONT_FAMILY = {
    ARCHIVO: {
        BOLD: 'Archivo-Bold',
        EXTRABOLD: 'Archivo-Extrabold',
        MEDIUM: 'Archivo-Medium',
        REGULAR: 'Archivo-Regular',
        SEMIBOLD: 'Archivo-SemiBold',
    },
};
